import $ from 'jquery'

export function init() {
  $('[data-menu-toggle]').on('click', function (event) {
    changeFlexWidth()
    event.stopPropagation()
  })
}

export function changeFlexWidth() {
  let headerOffset = $('.header-inner').offset().left
  let menuBgOffset = $('.header-offset').offset().left
  console.log(headerOffset)
  console.log(menuBgOffset)
  $('.menu-flex').css('flex-basis', menuBgOffset - headerOffset + 'px')
}
